import * as React from "react"
import {map as _map} from "lodash"
import * as $ from "jquery"
import {IPatientVitalHistory, IPatientVitalResponse} from "./../models/IPatientVitalResponse"
import {Chart} from "react-google-charts"
import AppUtils from "../utils/AppUtils";

/**
 * Created by aditya on 26/02/18.
 */

export const vitalToChartColorMapping = [
    { name: "TEMPERATURE", color: "#778dff"},
    { name: "BMI", color: "#778dff"},
    { name: "PULSE RATE", color: "#fcbb24"},
    { name: "SPO2", color: "#e2431e"},
    { name: "RESPIRATORY RATE", color: "#37e3f5"},
    { name: "WEIGHT", color: "#fcbb24"},
    { name: "HEIGHT", color: "#e2431e"},
    { name: "BP", color: "#37e3f5"},
    { name: "SYSTOLIC BP", color: "#37e3f5"},
    { name: "DIASTOLIC BP", color: "#37e3f5"},
    { name: "WAIST", color: "#778dff"},
    { name: "HIP", color: "#fcbb24"},
    { name: "WHR", color: "#e2431e"},
    { name: "WAIST GIRTH", color: "#789382"},
]

export interface PatientVitalsViewProps {
    currentValue: string;
    averageValue: string;
    rows: any;
    chartName: string;
    rootClass: string;
    subClass: string;
    title: string;
}


export interface PatientVitalsViewState {

}

export const VitalsChartOptions: any = {
    // curveType: "function",
    pointsVisible: true,
    legend: {position: "none"},
    backgroundColor: "#f1f5f8",
    hAxis: {baselineColor: "lightgrey", gridlines: {color: "transparent"}, textStyle: {color: "transparent"}},
    vAxis: {baselineColor: "transparent", gridlines: {color: "transparent"}, textStyle: {color: "grey"}},
    tooltip: {isHtml: true},
    interpolateNulls: true
}

const columnDefinition = [{type: "number", role: "domain", label: "Timeline"},
                        {type: "number", role: "data", label: "value"},
                        {type: "string", role: "tooltip", p: {"html": true}}];

const columnDefinitionBP = [{type: "number", role: "domain", label: "Timeline"},
                            {type: "number", role: "data", label: "value"},
                            {type: "string", role: "tooltip", p: {"html": true}},
                            {type: "number", role: "data", label: "value2"},
                            {type: "string", role: "tooltip", p: {"html": true}}];

class ChartComponent extends React.Component<PatientVitalsViewProps, PatientVitalsViewState> {

    constructor(props: PatientVitalsViewProps) {
        super(props);
    }

    showChart(event: any) {
        $(event.target).closest(".vital-chart-body").toggleClass("expanded");
    }

    generateDataTable = (rawData: IPatientVitalHistory[], vitalName: string) => {
        // let vitalsData = this.props.patientVitals[4].vitalHistoryList;
        let chartData = [["Index", vitalName, "role"]];
        _map(rawData, (vital, index) => {
            let item = [];
            item.push(vital.recordDate);
            item.push(parseInt(vital.value));
            item.push(AppUtils.getRelativeDay(vital.recordDate, "D MMM Y", true));
            chartData.push(item as any);
        })

        return chartData;
    }

    generateRows = (chartData: any) => {
        let rowArray: any = [];
        _map(chartData, (chartItem: any, index) => {
            let item = [];
            item.push(chartItem.recordDate);
            item.push(parseInt(chartItem.value));
            let hoverItem = `<div style="padding: 5px; min-width: 50px"><div style="font-size: 14px">${chartItem.value}</div><div style="font-size: 8px">${AppUtils.getRelativeDay(chartItem.recordDate, "D MMM Y", true)}</div></div>`;
            // item.push(chartItem.value + "<br/>" + AppUtils.getRelativeDay(chartItem.recordDate, "D MMM Y", true));
            item.push(hoverItem);
            rowArray.push(item as any);
        })
        return rowArray;
    }

    render() {
        let rows = this.props.rows;
        let columnDefs = this.props.chartName !== "bp" ? columnDefinition : columnDefinitionBP;
        let chartOptions = { ...VitalsChartOptions };
        let chartColor = { 0: { color: vitalToChartColorMapping.filter(item => item.name.toString() === this.props.chartName.toString().toUpperCase() )[0].color } };
        chartOptions.series = chartColor;
        return (
            <div className={`${this.props.rootClass} in-blk top-align`}>
                <div className={`${this.props.subClass}-name brandon-bold`}>{this.props.title}</div>
                <div className={`${this.props.subClass}-info-card`}>
                    <div className={`${this.props.subClass}-info-header`}>
                        <span className={`${this.props.subClass}-current-label pull-left`}>Current</span>
                        <span className={`${this.props.subClass}-average-laber pull-right`}>Average</span>
                    </div>

                    <div className={`${this.props.subClass}-info-body`}>
                        <span className={`${this.props.subClass}-current pull-left`}>{this.props.currentValue}</span>
                        <span className={`${this.props.subClass}-average pull-right`}>{this.props.averageValue}</span>
                    </div>

                    <div className={`${this.props.subClass}-chart-body expanded`}>
                        <div id={"chart-container"}>
                            <Chart
                                chartType="LineChart"
                                // data={myInstance.generateDataTable(this.props.chartData, this.props.chartName)}
                                rows={rows}
                                columns={columnDefs}
                                options={chartOptions}
                                graph_id={`LineChart-${this.props.chartName}`}
                                width="100%"
                                height="200px"
                                legend_toggle
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ChartComponent